import { render, staticRenderFns } from "./QueryForm.vue?vue&type=template&id=72aa8c98&scoped=true&"
import script from "./QueryForm.vue?vue&type=script&lang=js&"
export * from "./QueryForm.vue?vue&type=script&lang=js&"
import style0 from "./QueryForm.vue?vue&type=style&index=0&id=72aa8c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa8c98",
  null
  
)

export default component.exports